/** Route of the sign-in page. */
export const LOGIN_PATH = '/login';
